import { memo } from 'react';

/**
 * LoadingSkeleton - Pure presentational component
 * Wrapped in React.memo to prevent unnecessary re-renders
 */
const LoadingSkeleton = memo(function LoadingSkeleton({ type = 'card', count = 1 }) {
  const skeletons = Array(count).fill(0);

  if (type === 'card') {
    return (
      <>
        {skeletons.map((_, index) => (
          <div key={index} className="skeleton-card">
            <div className="skeleton skeleton-title"></div>
            <div className="skeleton skeleton-text"></div>
            <div className="skeleton skeleton-text"></div>
          </div>
        ))}
      </>
    );
  }

  if (type === 'table-row') {
    return (
      <>
        {skeletons.map((_, index) => (
          <div key={index} className="skeleton-table-row">
            <div className="skeleton skeleton-text"></div>
            <div className="skeleton skeleton-text"></div>
            <div className="skeleton skeleton-text"></div>
          </div>
        ))}
      </>
    );
  }

  if (type === 'profile') {
    return (
      <div className="skeleton-profile">
        <div className="skeleton skeleton-avatar"></div>
        <div className="skeleton skeleton-title"></div>
        <div className="skeleton skeleton-text"></div>
      </div>
    );
  }

  // Default - simple line
  return (
    <>
      {skeletons.map((_, index) => (
        <div key={index} className="skeleton skeleton-line"></div>
      ))}
    </>
  );
});

export default LoadingSkeleton;
